const loadMoreButtons = document.querySelectorAll(
	'.block-content-table .load-more-button-wrapper .btn-load-more'
);

const contentTableSections = document.querySelectorAll('.block-content-table');


const loadMoreTableRows = (e) => {
	e.preventDefault();
	const currentContentTableSection = e.currentTarget.closest('.block-content-table');
	const currentContentTableSectionLoadMoreButtonWrapper = e.currentTarget.closest('.load-more-button-wrapper');
	const allTableRows = currentContentTableSection.querySelectorAll('.block-content-tabletable tbody tr');
	const hiddenRows = currentContentTableSection.querySelectorAll('.block-content-table table tbody tr.hidden');
	const numOfRowsVisible = parseInt(allTableRows.length) - parseInt(hiddenRows.length);
	let numOfRowsToShow = 10;
	if(allTableRows.length < 10){
		numOfRowsToShow = hiddenRows.length;
	}
	if(numOfRowsVisible < allTableRows.length) {
		for (let i = 0; i < numOfRowsToShow; i++) {
			hiddenRows[i].classList.remove('hidden');
		}
		const newTotalVisibleRows = parseInt(numOfRowsVisible) + parseInt(numOfRowsToShow);
		if(newTotalVisibleRows >= allTableRows.length){
			currentContentTableSectionLoadMoreButtonWrapper.classList.remove('active');
		}
	}



};

const hideExtraTableRows = () => {
	if (loadMoreButtons.length) {
		loadMoreButtons.forEach((loadMoreButton) => {
			loadMoreButton.addEventListener('click', loadMoreTableRows);
		});
	}

	for (let x = 0; x < contentTableSections.length; x++) {
		const contentTableSection = contentTableSections[x];
		const rows = contentTableSection.querySelectorAll('.block-content-table table tbody tr');
		const loadMoreButtonWrapper = contentTableSection.querySelector('.load-more-button-wrapper');
		const rowsToShow = 10;
		if(rows.length > 10) {
			for (let i = rowsToShow; i < rows.length; i++) {
				rows[i].classList.add('hidden');
			}
			loadMoreButtonWrapper.classList.add('active');
		}
	}

};

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
        hideExtraTableRows();
	},	
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller; 
